module.exports = __webpack_public_path__ + "400fe2fd850b84c73bab52268e3f11e4.png";